export default "__VITE_ASSET__Ckrx8_kE__"